import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster, ToastBar, toast as _hotToast } from 'react-hot-toast'; /* [PATCH toast-zapri v1] */
import { useAuthStore } from './stores/authStore';
import { LoginPage } from './pages/LoginPage';
import { PovabiloPage } from './pages/PovabiloPage';
import { PozabljenoGesloPage, PonastaviGesloPage } from './pages/PozabljenoGesloPage'; // [PATCH pozabljeno-geslo-fe v1]
/* [PATCH dostopi-pravice v1] UporabnikiPage: ruta /uporabniki preusmerjena na /upravljanje (Dostopi in pravice) */
import { SuperadminPage } from './pages/SuperadminPage';
import { SuperadminPorabaPage } from './pages/SuperadminPorabaPage';
import { SuperadminBazePage } from './pages/SuperadminBazePage'; /* [PATCH superadmin-ploscice v1] */
import { SuperadminDeloPage } from './pages/SuperadminDeloPage'; /* [PATCH pregled-dela v4] */
import { PlacilaPage } from './pages/PlacilaPage';
import { DnevnikPage } from './pages/DnevnikPage';
import { LogistikaPage } from './pages/LogistikaPage';
import { LogistikaTransportPage } from './pages/LogistikaTransportPage';
import { InsolventnostPage } from './pages/InsolventnostPage';
import { MailVhodPage } from './pages/MailVhodPage';  // [PATCH mail-vhod-D2 v1]
import { DashboardLayout } from './components/layout/DashboardLayout';
import { DashboardPage } from './pages/DashboardPage';
import { NadzornaRuta } from './components/NadzornaRuta'; // [PATCH nadzorna-stranka v1]
import { MojaPodjetjaPage } from './pages/MojaPodjetjaPage';
import { DokumentiPage } from './pages/DokumentiPage';
import OnboardingPage from './pages/OnboardingPage';
import { SifrantiPage } from './pages/SifrantiPage';
import { AgentiPage } from './pages/AgentiPage';
import { ProgramiPage } from './pages/ProgramiPage';
import { ProfilPage } from './pages/ProfilPage';
import { PrenosiPage } from './pages/PrenosiPage';
import { NastavitvePage } from './pages/NastavitvePage'; // [PATCH bizbox-prevzem v6]
import { MojRacunPage } from './pages/MojRacunPage'; // [PATCH moj-racun v1]
import { NapakePage } from './pages/NapakePage'; // [PATCH napake-fe v2]
import { ObvestilaPage } from './pages/ObvestilaPage'; // [PATCH objave-fe v1]
import { PdfWindow } from './components/PdfViewer';
import { EdavkiPage } from './pages/EdavkiPage';  // [PATCH edavki-ruta v1]
import { SinhronizacijaPage } from './pages/SinhronizacijaPage';  // [PATCH opal-k8 v1]
import { IzdajaDokumentPage } from './pages/izdaja/IzdajaDokumentPage'; // [PATCH izdaja-ui v1]
import { IzbiraAplikacijePage } from './pages/IzbiraAplikacijePage'; // [PATCH aplikacije-fe v1]
import { VstopAplikacijeRuta } from './pages/VstopAplikacijeRuta'; // [PATCH aplikacije-fe v1]
import { IzbiraPodjetjaPage } from './pages/IzbiraPodjetjaPage'; // [PATCH aplikacije-fe v1]
/* [PATCH dostopi-pravice v1] UporabnikiAplikacijPage: ruta /uporabniki-aplikacije preusmerjena na /upravljanje */
import { PregledPage } from './pages/PregledPage'; // [PATCH pregled-poslovanja-fe v1]
import { ProdajaPregledPage } from './pages/ProdajaPregledPage'; // [PATCH prodaja-pregled-fe v1]
import { NabavaPregledPage } from './pages/NabavaPregledPage'; // [PATCH nabava-pregled-fe v1]
import { KadriPage } from './pages/KadriPage'; // [PATCH pn-dc-fe v1]
import { PotniNalogiPage, NameniPotiPage, VozilaPage, PnSifrantiPage } from './pages/PotniNalogiPage'; /* [PATCH pn-vozila-19b v1] [PATCH pn-22 v1] */
import { MojMesecPage } from './pages/DelovniCasPage'; /* [PATCH dc2 v1] */
import { PregledDelaDcPage } from './pages/PregledDelaDcPage'; /* [PATCH dc-pregled v1] */
import { DcSkupinaPage } from './pages/DcSkupinaPage'; /* [PATCH dc-skupina-fe v1] */
import { PnPrenosPage } from './pages/PnPrenosPage'; /* [PATCH pn-prenos-kn21 v1] */
import { UpravljanjePage } from './pages/UpravljanjePage'; /* [PATCH pravice-p3 v1] */ // [PATCH pn-nalog-fe v1] [PATCH pn-nalog-15b v1]
import { BankaPage, BankaNastavitvePage, BankaPravilaPage, BankaPrenosPage } from './pages/BankaPage'; /* [PATCH banka-f4 v1] */ // /* [PATCH banka-f1 v1b] [PATCH banka-f2 v1b] */


function PrivateRoute({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.token);
  return token ? <>{children}</> : <Navigate to="/prijava" />;
}

export default function App() {
  const { theme } = useAuthStore();
  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);
  return (
    <BrowserRouter>
      {/* [PATCH toast-zapri v1] vsako obvestilo ima gumb za zapiranje */}
      <Toaster position="top-right">
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== 'loading' && (
                  <button
                    type="button"
                    onClick={() => _hotToast.dismiss(t.id)}
                    aria-label="Zapri obvestilo"
                    title="Zapri"
                    className="ml-1 -mr-1 px-1.5 text-lg leading-none text-gray-400 hover:text-gray-700"
                  >
                    ×
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
      <Routes>
        <Route path="/prijava" element={<LoginPage />} />
        <Route path="/pdf-viewer" element={<PdfWindow />} />
        <Route path="/povabilo/:token" element={<PovabiloPage />} />
        <Route path="/pozabljeno-geslo" element={<PozabljenoGesloPage />} />{/* [PATCH pozabljeno-geslo-fe v1] */}
        <Route path="/ponastavi-geslo/:zeton" element={<PonastaviGesloPage />} />{/* [PATCH pozabljeno-geslo-fe v1] */}
        {/* [PATCH aplikacije-fe v1] vstop zunaj okvirja: izbira aplikacije (/), vstopna ruta, izbira podjetja */}
        <Route path="/" element={<PrivateRoute><IzbiraAplikacijePage /></PrivateRoute>} />
        <Route path="/app/:aplikacija" element={<PrivateRoute><VstopAplikacijeRuta /></PrivateRoute>} />
        <Route path="/izbira-podjetja" element={<PrivateRoute><IzbiraPodjetjaPage /></PrivateRoute>} />
        <Route element={<PrivateRoute><DashboardLayout /></PrivateRoute>}>{/* [PATCH aplikacije-fe v1] okvir brez path="/"; otroci ostanejo /podjetja, /dokumenti ... */}
          <Route path="podjetja" element={<MojaPodjetjaPage />} />
          <Route path="nadzorna" element={<NadzornaRuta />} />{/* [PATCH nadzorna-stranka v1] stranka -> / */}{/* [PATCH aplikacije-fe v1] prej index (/) */}
          <Route path="dokumenti" element={<DokumentiPage />} />
          <Route path="onboarding" element={<OnboardingPage />} />
          <Route path="sifranti" element={<SifrantiPage />} />
          <Route path="agenti" element={<ProgramiPage />} />
          <Route path="agenti/:program" element={<AgentiPage />} />
          <Route path="profil" element={<ProfilPage />} />
          <Route path="nastavitve" element={<NastavitvePage />} />
          <Route path="moj-racun" element={<MojRacunPage />} /> {/* [PATCH moj-racun v1] */}
          <Route path="napake" element={<NapakePage />} /> {/* [PATCH napake-fe v2] */}
          <Route path="obvestila" element={<ObvestilaPage />} /> {/* [PATCH objave-fe v1] */}
          <Route path="prenosi" element={<PrenosiPage />} />
          <Route path="uporabniki" element={<Navigate to="/upravljanje" replace />} />{/* [PATCH dostopi-pravice v1] */}
          <Route path="uporabniki-aplikacije" element={<Navigate to="/upravljanje" replace />} />{/* [PATCH dostopi-pravice v1] prej UporabnikiAplikacijPage */}
          <Route path="upravljanje" element={<UpravljanjePage />} />{/* [PATCH pravice-p3 v1] */}
          <Route path="superadmin" element={<SuperadminPage />} />
          <Route path="superadmin/poraba" element={<SuperadminPorabaPage />} />
          {/* [PATCH superadmin-ploscice v1] */}
          <Route path="superadmin/baze" element={<SuperadminBazePage />} />
          <Route path="superadmin/delo" element={<SuperadminDeloPage />} /> {/* [PATCH pregled-dela v4] */}
          <Route path="placila" element={<PlacilaPage />} />
          <Route path="dnevnik" element={<DnevnikPage />} />
          <Route path="logistika" element={<LogistikaPage />} />
          <Route path="logistika/:transportId" element={<LogistikaTransportPage />} />
          <Route path="insolventnost" element={<InsolventnostPage />} />
          <Route path="eposta" element={<MailVhodPage />} /> {/* [PATCH mail-vhod-D2 v1] */}
          <Route path="edavki" element={<EdavkiPage />} />
          {/* [PATCH opal-k8 v1] cakalnica Opal sync (korak D) */}
          <Route path="sinhronizacija" element={<SinhronizacijaPage />} />
          {/* [PATCH izdaja-ui v1] modul Izdaja: pregled, nov dokument, dokument */}
          <Route path="izdaja" element={<Navigate to="/dokumenti?tip=izdani_racun&pogled=rocni" replace />} />{/* [PATCH izdaja-dokumenti v1] pregled je v Dokumentih */}
          <Route path="izdaja/nov/:tip" element={<IzdajaDokumentPage />} />
          <Route path="izdaja/:dokId" element={<IzdajaDokumentPage />} />
          <Route path="pregled" element={<PregledPage />} />{/* [PATCH pregled-poslovanja-fe v1] */}
          <Route path="prodaja-pregled" element={<ProdajaPregledPage />} />{/* [PATCH prodaja-pregled-fe v1] */}
          <Route path="nabava-pregled" element={<NabavaPregledPage />} />{/* [PATCH nabava-pregled-fe v1] */}
          <Route path="kadri" element={<KadriPage />} />{/* [PATCH pn-dc-fe v1] Potni nalogi + Delovni čas */}
          <Route path="potni-nalogi" element={<PotniNalogiPage />} />{/* [PATCH pn-nalog-fe v1] */}
          <Route path="potni-nalogi/:nid" element={<PotniNalogiPage />} />{/* [PATCH pn-nalog-fe v1] */}
          <Route path="nameni-poti" element={<NameniPotiPage />} />{/* [PATCH pn-nalog-15b v1] */}
          <Route path="pn-prenos" element={<PnPrenosPage />} />{/* [PATCH pn-prenos-kn21 v1] */}
          <Route path="vozila" element={<VozilaPage />} />{/* [PATCH pn-vozila-19b v1] */}
          <Route path="pn-sifranti" element={<PnSifrantiPage />} />{/* [PATCH pn-22 v1] */}
          <Route path="moj-mesec" element={<MojMesecPage />} />{/* [PATCH dc2 v1] */}
          <Route path="dc-skupina" element={<DcSkupinaPage />} />{/* [PATCH dc-skupina-fe v1] */}
          <Route path="dc-pregled" element={<PregledDelaDcPage />} />
          <Route path="banka" element={<BankaPage />} />{/* [PATCH banka-f1 v1b] */}
          <Route path="banka/nastavitve" element={<BankaNastavitvePage />} />{/* [PATCH banka-f1 v1b] */}
          <Route path="banka/pravila" element={<BankaPravilaPage />} />{/* [PATCH banka-f2 v1b] */}
          <Route path="banka/prenos" element={<BankaPrenosPage />} />{/* [PATCH banka-f4 v1] */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
